<template>
  <div
    v-loading="loading"
    :element-loading-text="loadingText"
    element-loading-spinner="el-icon-loading"
  >
    <div>
      <!-- <el-button type="success" size="mini" icon="el-icon-arrow-left" @click="goBack"
        style="background-color:#008A2C;float: left;">返回个人中心
      </el-button> -->
      <div @click="goBack" style="cursor: pointer; color: #008a2c">
        <el-button
          type="info"
          style="background-color: #008a2c"
          icon="el-icon-back"
          circle
        ></el-button>
        &nbsp;返回个人中心
      </div>
      <div class="f20 tc">{{ detailData.f1 }}-详情</div>
    </div>
    <el-row :gutter="20" style="margin-top: 30px">
      <el-col :span="5" :offset="4">
        <div><span class="fb">申请事项：</span>{{ detailData.f1 }}</div>
      </el-col>
      <el-col :span="5">
        <div><span class="fb">申请人：</span>{{ detailData.applyUser }}</div>
      </el-col>
      <el-col :span="5">
        <div>
          <span class="fb">申请时间：</span
          >{{ moment(detailData.applyTime).format("YYYY-MM-DD HH:mm:ss") }}
        </div>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <!-- <div style="border:1px solid #ECECEC;margin-bottom: 10px;padding: 10px;">
    
    </div> -->
    <el-row :gutter="20">
      <el-col :span="18">
        <div style="min-height: 600px; border: 1px solid #ececec">
          <iframe
            style="position: relative"
            name="iframeID"
            id="iframeID"
            width="100%"
            height="600px"
            :src="detailUrl"
            frameborder="0"
          ></iframe>
        </div>
      </el-col>
      <el-col :span="6">
        <div style="min-height: 600px; border: 1px solid #ececec">
          <div class="rightbox">审批记录</div>
          <div style="padding: 15px">
            <el-steps direction="vertical" :active="active">
              <el-step
                title=""
                :status="
                  item.result == 1
                    ? 'wait'
                    : item.result == 2
                    ? 'success'
                    : item.result == 3
                    ? 'error'
                    : ''
                "
                v-for="item in matterData1"
                :key="item.id"
                :icon="item.result!=2?'el-icon-circle-check':''"
              >
                <div slot="title">
                  <p>{{ item.name }}</p>
                </div>
                <div
                  slot="description"
                  style="color: black; margin-bottom: 10px"
                >
                  <p>
                    {{ moment(item.createTime).format("YYYY-MM-DD HH:mm:ss") }}
                  </p>
                  <p>
                    <span style="font-weight: bold">{{
                      item.assigneeUser.nickname
                    }}</span>
                    <span>【{{ item.assigneeUser.deptName }}】</span>
                  </p>
                  <p>审批意见：</p>
                  <p>{{ item.reason }}</p>
                </div>
              </el-step>
              <el-step :status="isStatus" title=""><div slot="title" >
                  <p>事项办理结束</p>
                </div></el-step>
              <!-- <el-step title="2022.10.20 17:12:21"  process-status="error" icon="el-icon-circle-close">
                <div slot="description" style="color:black;margin-bottom: 10px;">
                  <p>张三 物联网研究院</p>
                  <p>审批意见：</p>
                  <p>xxxxxxx</p>
                </div>
              </el-step>
              <el-step title="步骤 3">
                <div slot="description" style="color:black;margin-bottom: 10px;">
                  <p>张三 物联网研究院</p>
                  <p>审批意见：</p>
                  <p>xxxxxxx</p>
                </div>
              </el-step> -->
            </el-steps>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from "vuex";
import { queryMatter, queryRunById } from "@/api/matter.js";
export default {
  name: "matterInfo",
  data() {
    return {
      detailUrl: "",
      matterData: [],
      matterData1: [],
      matterid: "",
      runid: "",
      detailid: "",
      detailData: {},
      active: 1,
      loadingText: "数据正在加载中，请稍后...",
      loading: true,
      isStatus: "wait",
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
  },
  mounted() {
    this.runid = this.$route.query.runid;
    this.detailid = this.$route.query.detailid;
    this.matterid = this.$route.query.id;
    this.detailUrl = "../SMRDetaileIframe?id=" + this.detailid;
    this.getMatter();
    setTimeout(() => {
      this.loading = false;
    }, 200);
  },
  methods: {
    moment,
    async getMatter() {
      await queryMatter(this.matterid).then((res) => {
        if (res.code == 0) {
          let json = JSON.stringify(res.data);
          this.matterData = JSON.parse(json);
          this.active = this.matterData.length - 1;
          if (this.matterData[0]?.result == 2) {
            this.active = this.matterData.length;
          } else {
            this.active = this.matterData.length - 1;
          }
          this.matterData1 = JSON.parse(json).reverse();
          this.getRunById();
        }
      });
    },
    async getRunById() {
      const data = await queryRunById(this.runid);
      console.log(data, 1111111111111,this.matterData[0]?.result);
      this.detailData = data.data;
      if (this.detailData.runState == 1&&this.matterData[0]?.result == 2) {
        this.isStatus = "success";
      }else if(this.detailData.runState == 1&&this.matterData[0]?.result == 3){
        this.isStatus = "error";
      }
      if (this.detailData.f1 === "门禁授权申请") {
        this.detailUrl =
          "../accessAuthorizationDetailIframe?id=" + this.detailid;
      } else if (this.detailData.f1 === "校史馆参观预约") {
        this.detailUrl = "../SMRDetaileIframe?id=" + this.detailid;
      } else if (this.detailData.f1 === "《普通高等学校录取新生名册》查询复印服务") {
        this.detailUrl = "../admissionRosterCopyDetaileIframe?id=" + this.detailid;
      }else if (this.detailData.f1 === "档案查询预约"){
        this.detailUrl = "../archiveQueryDetails?id=" + this.detailid;
      }
    },
    goBack() {
      this.$router.push("/userCenter");
    },
  },
};
</script>
<style>
.rightbox {
  border-bottom: 2px solid #ececec;
  text-align: center;
  font-size: 24px;
  padding: 5px 0px;
  background-color: #e2f3cf;
}
.el-step__head.is-finish {
  color: #008a2c;
}

.el-step__head.is-process {
  color: red;
}
</style>